var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUrlLink = function SvgUrlLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.389 4.889a.944.944 0 1 1 0-1.889h5.667a.944.944 0 0 1 .944.944v5.667a.945.945 0 0 1-1.889 0V6.225L10.334 15A.945.945 0 0 1 9 13.666l8.777-8.777h-3.387ZM4 6.778c0-1.043.846-1.89 1.889-1.89h4.722a.944.944 0 1 1 0 1.89H5.89V18.11h11.333V13.39a.945.945 0 0 1 1.89 0v4.722A1.889 1.889 0 0 1 17.221 20H5.89A1.889 1.889 0 0 1 4 18.111V6.778Z",
    fill: "currentColor"
  })));
};
export default SvgUrlLink;